(function($){

  $.fn.quantity = function(options) {

    var settings = $.extend({
      'listener': null,
      'eventHandler': 'click',
      'afterAttach': null,
      'onClick': null,
      'onChange': null,
      'onBlur': null,
      'afterClick': null,
      'onKeyUp': null,
      'readonly': false
    }, options);

    var listenerAdded = false;

    return this.each(function() {
      var $this = $(this);

      $this.attr('readonly', settings.readonly);
      $this.before('<button type="button" class="form-control quantity qtyBtn qtyBtn--dec">-</button>');
      $this.after('<button type="button" class="form-control quantity qtyBtn qtyBtn--inc">+</button>');

      if($.isFunction(settings.afterAttach)) {
        settings.afterAttach.call();
      }

      if(!settings.listener) {
        $this.siblings('.qtyBtn').on(settings.eventHandler, function(e) {
          e.preventDefault();
          logic(e);
        });
        if(settings.onChange) {
          $this.on('change', function(e) {
            if($.isFunction(settings.onChange)) {
              settings.onChange.call(this, e);
            }
          })
        }
        if($.isFunction(settings.onKeyUp)) {
          $this.on('keyup', function(e) {
            settings.onKeyUp.call(this, e);
          });
        }
      } else {
        if(!listenerAdded) {
          $(settings.listener).on(settings.eventHandler, '.qtyBtn', function(e) {
            e.preventDefault();
            logic(e);
          });
          if(settings.onChange) {
            $(settings.listener).on('change', '.js-quantity', function(e) {
              if($.isFunction(settings.onChange)) {
                settings.onChange.call(this, e);
              }
            });
          }
          if(settings.onBlur) {
            $(settings.listener).on('blur', '.js-quantity', function(e) {
              if($.isFunction(settings.onBlur)) {
                settings.onBlur.call(this, e);
              }
            });
          }
          if(settings.onKeyUp) {
            $(settings.listener).on('keyup', '.js-quantity', function(e) {
              if($.isFunction(settings.onKeyUp)) {
                  settings.onKeyUp.call(this, e);
              }
            });
          }
          listenerAdded = true;
        }
      }

      function logic(e) {
        e.preventDefault();

        if($.isFunction(settings.onClick)) {
          settings.onClick.call(this, e);
        }

        var $button = $(e.currentTarget),
          $input = $button.parent().find("input[type='text']"),
          oldValue = $input.val();

        if ($button.hasClass('qtyBtn--inc')) {
          var newVal = parseInt(oldValue) + 1;
        } else {
          // Don't allow decrementing below zero
          if (oldValue > 0) {
            var newVal = parseInt(oldValue) - 1;
          } else {
            newVal = 0;
          }
        }

        if (isNaN(newVal)) {
          newVal = 0;
        }

        $input.val(newVal);

        if($.isFunction(settings.afterClick)) {
          settings.afterClick.call(this, e);
        }
      }

    });
  }

})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/quantity.js